import { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { ResponseIngresoMutuo } from "../models/responseIngresoMutuo";

export interface BooleanResultResponse {
    valor: boolean;
}

const getMutuo = async (mutuoId: number) => {

    const axiosResponse: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-mutuo/v1/mutuo/obtener-mutuo-aprobado`, {
        params: {
            mutuoId: mutuoId
        }
    });

    return axiosResponse;
}

const getValidarMutuo = async (mutuoId: number) => {

    const axiosResponse: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-mutuo/v1/mutuo/validar-mutuo`, {
        params: {
            mutuoId: mutuoId
        }
    });

    return axiosResponse;

}

const patchAprobarMutuo = async (mutuoId: number) => {

    const axiosResponse: Promise<AxiosResponse> = axiosInstance.get(`siscred-api-mutuo/v1/mutuo/aprobar-mutuo`, {
        params: {
            mutuoId: mutuoId
        }
    });

    return axiosResponse;

}

const ingresarMutuo = async (numeroSolicitud: string, tipoMutuo: string): Promise<AxiosResponse<ResponseIngresoMutuo>> => {

    return axiosInstance.get<ResponseIngresoMutuo>(`siscred-api-bandeja-mutuos/v1/mutuos/ingreso-mutuo`,
        {
            params: {
                numeroSolicitud: numeroSolicitud,
                tipoSolicitud: tipoMutuo
            }
        }
    );
};

const IsDesactivado = async (mutuoId: number) => {

    const axiosResponse: Promise<AxiosResponse<BooleanResultResponse>> = axiosInstance.get(`siscred-api-mutuo/v1/mutuo/es/${mutuoId}/desactivado`, {
        params: {
            mutuoId: mutuoId
        }
    });

    return axiosResponse;

}
const isVigente = async (mutuoId: number) => {

    const axiosResponse: Promise<AxiosResponse<BooleanResultResponse>> = axiosInstance.get(`siscred-api-mutuo/v1/mutuo/es/${mutuoId}/vigente`, {
        params: {
            mutuoId: mutuoId
        }
    });

    return axiosResponse;

}

export {
    getMutuo,
    getValidarMutuo,
    patchAprobarMutuo,
    ingresarMutuo,
    IsDesactivado,
    isVigente
}